export default "__VITE_ASSET__401c0273__"